import * as React from 'react';
import type {AssetGroup} from '@deviceinsight/ng-ui-api-client';
import type {UiCondition} from '../../../modules/ruleengine/types';
import TriggerRuleCondition from './TriggerRuleCondition';
type Props = {
	conditions: UiCondition;
	assetGroup: AssetGroup;
	onReset: (id: string) => void;
};

const TriggerRuleConditionsContainer = ({conditions, onReset}: Props) => {
	return (
		<div className="rule-condition-container">
			{conditions && conditions.nestedConditions && conditions.nestedConditions.length ? (
				conditions.nestedConditions.map((nc, idx) => (
					<TriggerRuleCondition key={idx} condition={nc} onReset={onReset} />
				))
			) : (
				<TriggerRuleCondition condition={conditions} onReset={onReset} />
			)}
		</div>
	);
};

export default TriggerRuleConditionsContainer;
